(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beaute-fragrance-quiz"] && !Shopify.designMode) return;
  try {
    
const scentGroups = {
 fresh:['Fresh','Aquatic','Aromatic','Green','Fougere','Aldehydic'], citrus:['Citrus'],
 floral:['Floral','White Floral','Rose','Jasmine','Iris'], fruity:['Fruity','Tropical'],
 warm:['Spicy','Amber','Oriental','Resinous','Incense'], woody:['Woody','Earthy','Patchouli','Chypre'],
 sweet:['Gourmand','Sweet','Honey','Tonka Bean'], deep:['Leather','Oud','Tobacco','Smoky'], soft:['Musk','Powdery']
};
const occasionGroups = {everyday:['Everyday','Casual','Daytime','Day','Signature','Sport'],work:['Business','Office'],date:['Romantic'],evening:['Evening','Night','Night Out'],special:['Formal','Special','Special Occasion','Wedding']};
const intensityLevels = ['Light','Moderate','Strong','Intense'];
const splitTags = value => (value || '').split(',').map(v=>v.trim().toLowerCase());
function scoreFragrance(product, answers) {
 const genders=Array.isArray(answers.gender)?answers.gender:[answers.gender];
 if (!genders.includes('all') && !genders.some(g=>product.gender.includes(g))) return null;
 const parts = {scent:0,intensity:0,occasion:0,season:0};
 let total = 0;
 const chosen = answers.scents.filter(s=>s !== 'any');
 if (chosen.length) {total += 50; parts.scent = chosen.filter(s=>scentGroups[s].some(t=>product.scents.includes(t))).length * 50 / chosen.length;}
 if (answers.intensity !== 'any') {total+=25; const d=Math.abs(intensityLevels.indexOf(product.intensity)-intensityLevels.indexOf(answers.intensity)); parts.intensity=d===0?25:d===1?12.5:0;}
 if (answers.occasion !== 'any') {total+=15; parts.occasion=occasionGroups[answers.occasion].some(t=>splitTags(product.occasion).includes(t.toLowerCase()))?15:0;}
 if (answers.season !== 'any') {total+=10; const all=['all-season','all seasons','all year'].includes(product.season.trim().toLowerCase()); const tags=splitTags(product.season); parts.season=(all || (answers.season==='warm'&&tags.includes('summer')) || (answers.season==='cool'&&tags.includes('winter')))?10:0;}
 return {...product,parts,score:total?100*Object.values(parts).reduce((a,b)=>a+b,0)/total:0,discovery:total===0};
}
function rankFragrances(catalog, answers) {
 return catalog.map(p=>scoreFragrance(p,answers)).filter(Boolean).sort((a,b)=>b.score-a.score || b.parts.scent-a.parts.scent || b.parts.intensity-a.parts.intensity || a.title.localeCompare(b.title) || a.handle.localeCompare(b.handle));
}
function selectDistinct(candidates, limit=3) {
 const selected=[], used=new Set();
 while(selected.length<limit) {
  const rest=candidates.filter(p=>!used.has(p.group)); if(!rest.length)break;
  const best=rest[0], brands=new Set(selected.map(p=>p.vendor));
  const next=rest.find(p=>p.score===best.score&&p.parts.scent===best.parts.scent&&p.parts.intensity===best.parts.intensity&&!brands.has(p.vendor))||best;
  selected.push(next);used.add(next.group);
 }
 return selected;
}

class BeauteFragranceQuiz extends HTMLElement {
 connectedCallback() {
  if(this.initialized)return;this.initialized=true;
  this.data=JSON.parse(this.querySelector('[data-quiz-data]').textContent);
  this.copy=JSON.parse(this.querySelector('[data-quiz-copy]').textContent);
  this.answers={gender:[],scents:[],intensity:'',occasion:'',season:''};this.step=0;this.run=0;
  this.stage=this.querySelector('[data-stage]');this.progress=this.querySelector('progress');
  this.status=this.querySelector('[data-status]');this.addEventListener('click',e=>this.onClick(e));
  this.addEventListener('change',e=>this.onChange(e));this.render(false);
 }
 esc(value){return String(value).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));}
 get questions(){return this.copy.questions;}
 onChange(e){
  const input=e.target;if(!input.matches('[data-answer]'))return;
  const q=this.questions[this.step];
  if(q.key==='gender'){
   if(input.value==='all')this.answers.gender=input.checked?['all']:[];
   else {const selected=this.answers.gender.filter(g=>g!=='all'&&g!==input.value);if(input.checked)selected.push(input.value);this.answers.gender=selected;}
   this.stage.querySelectorAll('[data-answer]').forEach(el=>el.checked=this.answers.gender.includes(el.value));
  }else if(q.key==='scents'){
   if(input.value==='any'){this.answers.scents=input.checked?['any']:[];}
   else {let selected=this.answers.scents.filter(x=>x!=='any'&&x!==input.value);if(input.checked)selected.push(input.value);if(selected.length>2){input.checked=false;this.status.textContent=this.copy.choose_two;return;}this.answers.scents=selected;}
   this.stage.querySelectorAll('[data-answer]').forEach(el=>el.checked=this.answers.scents.includes(el.value));
  }else this.answers[q.key]=input.value;
  this.status.textContent='';this.stage.querySelector('[data-next]').disabled=!this.valid();
 }
 valid(){const v=this.answers[this.questions[this.step].key];return Array.isArray(v)?v.length>0:!!v;}
 onClick(e){
  const b=e.target.closest('button');if(!b||!this.contains(b))return;
  if(b.hasAttribute('data-next')&&this.valid()){if(this.step===4)this.results();else {this.step++;this.render();}}
  if(b.hasAttribute('data-back')){this.run++;this.step=Math.max(0,this.step-1);this.render();}
  if(b.hasAttribute('data-edit')){this.run++;this.step=0;this.render();}
  if(b.hasAttribute('data-restart')){this.run++;this.answers={gender:[],scents:[],intensity:'',occasion:'',season:''};this.step=0;this.render();}
  if(b.hasAttribute('data-retry'))this.results();
 }
 render(focus=true){
  this.removeAttribute('aria-busy');this.progress.value=this.step;this.status.textContent='';
  const q=this.questions[this.step];
  this.querySelector('[data-step]').textContent=this.copy.step.replace('{n}',this.step+1);
  this.stage.innerHTML=`<fieldset><legend tabindex="-1">${this.esc(q.title)}</legend><p class="bq-hint">${this.esc(q.hint)}</p><div class="bq-options ${q.key==='scents'?'bq-scents':''}">${q.options.map(o=>`<label class="bq-option"><input data-answer type="${['scents','gender'].includes(q.key)?'checkbox':'radio'}" name="bq-${this.id}-${q.key}" value="${this.esc(o.value)}" ${(Array.isArray(this.answers[q.key])?this.answers[q.key].includes(o.value):this.answers[q.key]===o.value)?'checked':''}><span><strong>${this.esc(o.label)}</strong>${o.detail?`<small>${this.esc(o.detail)}</small>`:''}</span></label>`).join('')}</div></fieldset><div class="bq-controls">${this.step?`<button type="button" class="bq-back" data-back>${this.esc(this.copy.back)}</button>`:'<span></span>'}<button type="button" class="bq-primary" data-next ${this.valid()?'':'disabled'}>${this.esc(this.step===4?this.copy.find:this.copy.next)} <span aria-hidden="true">→</span></button></div>`;
  if(focus)this.stage.querySelector('legend').focus({preventScroll:true});
 }
 async results(){
  const token=++this.run;this.progress.value=5;this.setAttribute('aria-busy','true');this.status.textContent='';
  this.querySelector('[data-step]').textContent=this.copy.results_label;
  this.stage.innerHTML=`<h2 tabindex="-1">${this.esc(this.copy.loading)}</h2><p>${this.esc(this.copy.loading_detail)}</p><button class="bq-back" type="button" data-edit>${this.esc(this.copy.edit)}</button>`;
  const ranked=rankFragrances(this.data,this.answers), cache=new Map(), available=[];let requests=0,failed=false,limited=false;
  const root=window.Shopify?.routes?.root||this.dataset.root||'/';
  const fetchProduct=async handle=>{
   if(!cache.has(handle))cache.set(handle,(async()=>{try{const r=await fetch(root+'products/'+encodeURIComponent(handle)+'.js',{signal:AbortSignal.timeout(6000)});if(r.status===404)return null;if(!r.ok)throw Error('product');return await r.json();}catch{failed=true;return null;}})());
   return cache.get(handle);
  };
  const start=Date.now();let chosen=[];
  for(let i=0;i<ranked.length;i+=6){
   if(token!==this.run)return;
   if(requests>=90||Date.now()-start>18000){limited=true;break;}
   const batch=ranked.slice(i,i+6);requests+=new Set(batch.filter(p=>!cache.has(p.handle)).map(p=>p.handle)).size;
   const live=await Promise.all(batch.map(p=>fetchProduct(p.handle)));
   batch.forEach((p,j)=>{const product=live[j];if(!product||String(product.id)!==p.productId)return;const variant=product.variants?.find(v=>String(v.id)===p.variantId);if(product.available&&variant?.available)available.push({...p,live:product,variant});});
   chosen=selectDistinct(available);
   if(chosen.length===3)break;
  }
  if(token!==this.run)return;
  chosen=selectDistinct(available);this.removeAttribute('aria-busy');
  const discovery=chosen.length&&chosen.every(p=>p.score===0);
  const currency=this.dataset.currency||'PKR';
  const money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency,maximumFractionDigits:0});
  this.stage.innerHTML=`<h2 tabindex="-1">${this.esc(chosen.length?(discovery?this.copy.discover_title:this.copy.results_title):this.copy.empty_title)}</h2><p class="bq-result-intro">${this.esc(chosen.length?(discovery?this.copy.discover_detail:this.copy.results_detail):(failed||limited?this.copy.error:this.copy.empty_detail))}</p>${chosen.length?`<div class="bq-results">${chosen.map(p=>{
   const url=root+'products/'+encodeURIComponent(p.handle)+'?variant='+p.variantId;
   const image=p.variant.featured_image?.src||p.live.featured_image;
   const label=(key,value)=>this.questions.find(q=>q.key===key).options.find(o=>o.value===value)?.label.toLowerCase()||value;
   const phrases=[];if(p.parts.scent)phrases.push(this.answers.scents.filter(s=>s!=='any'&&scentGroups[s].some(t=>p.scents.includes(t))).map(s=>label('scents',s)).join(' + '));if(p.parts.intensity===25)phrases.push(label('intensity',this.answers.intensity));if(p.parts.occasion)phrases.push(label('occasion',this.answers.occasion));if(p.parts.season)phrases.push(label('season',this.answers.season));
   return `<article class="bq-card">${image?`<a href="${this.esc(url)}" tabindex="-1" aria-hidden="true"><img src="${this.esc(image)}" alt="" width="400" height="400" loading="lazy"></a>`:''}<p class="bq-vendor">${this.esc(p.live.vendor)}</p><h3><a href="${this.esc(url)}">${this.esc(p.live.title)}</a></h3><p class="bq-reason">${this.esc(phrases.length?this.copy.reason_prefix+' '+phrases.join(', ')+'.':this.copy.discovery_card)}</p><p class="bq-tags">${this.esc(p.scents.join(' · '))}</p><p class="bq-price">${this.esc(money.format(p.variant.price/100))} <span>${this.esc(p.variant.title==='Default Title'?'':p.variant.title)}</span></p><a class="bq-primary" href="${this.esc(url)}">${this.esc(this.copy.shop)} <span aria-hidden="true">↗</span></a></article>`;
  }).join('')}</div>`:''}${failed||limited?`<p role="status">${this.esc(this.copy.partial)}</p><button type="button" class="bq-back" data-retry>${this.esc(this.copy.retry)}</button>`:''}<div class="bq-controls"><button type="button" class="bq-back" data-edit>${this.esc(this.copy.edit)}</button><button type="button" class="bq-back" data-restart>${this.esc(this.copy.restart)}</button></div>`;
  this.stage.querySelector('h2').focus({preventScroll:true});
 }
}
if(!customElements.get('beaute-fragrance-quiz'))customElements.define('beaute-fragrance-quiz',BeauteFragranceQuiz);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
